import { render, staticRenderFns } from "./DeleteReviewButton.vue?vue&type=template&id=ecefa732"
import script from "./DeleteReviewButton.vue?vue&type=script&lang=ts"
export * from "./DeleteReviewButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecefa732')) {
      api.createRecord('ecefa732', component.options)
    } else {
      api.reload('ecefa732', component.options)
    }
    module.hot.accept("./DeleteReviewButton.vue?vue&type=template&id=ecefa732", function () {
      api.rerender('ecefa732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/DeleteReviewButton.vue"
export default component.exports